import { add as addToCart } from '../objects/cart/ajax_cart';

// COB2B-804: PLP "you may like" for out-of-stock cards. Mirrors the Saved
// List behaviour (YourListDetail.jsx's YmlCard/fetchRecommendation) — same
// Shopify Recommendations endpoint, same "first available result" pick, same
// ajax add-to-cart — but PLP cards are server-rendered Liquid, not Preact, so
// this fetches/renders with vanilla DOM instead of a component.
const RECOMMENDATION_ENDPOINT = '/recommendations/products.json';

const escapeHtml = (value = '') => {
  const div = document.createElement('div');
  div.textContent = value;
  return div.innerHTML;
};

async function fetchRecommendation(productId) {
  if (!productId) return null;
  try {
    const res = await fetch(
      `${RECOMMENDATION_ENDPOINT}?product_id=${productId}&intent=related&limit=10`,
    );
    if (!res.ok) return null;
    const { products } = await res.json();
    const rec = (products || []).find((p) => p.available);
    if (!rec) return null;
    const variant = rec.variants?.find((v) => v.available) || rec.variants?.[0];
    if (!variant) return null;
    return {
      title: rec.title,
      url: rec.url,
      image: rec.featured_image || rec.images?.[0] || '',
      variantId: variant.id,
    };
  } catch {
    return null;
  }
}

function handleAdd(button, rec, texts) {
  if (button.disabled) return;

  const cartEl =
    document.querySelector('cart-notification') ||
    document.querySelector('cart-drawer');
  const notification = document.querySelector('cart-notification-popup');
  const sections = cartEl?.getSectionsToRender
    ? cartEl
        .getSectionsToRender()
        .map((s) => s.id)
        .toString()
    : '';

  button.disabled = true;
  button.textContent = texts.adding;

  addToCart(rec.variantId, 1, sections, (response) => {
    try {
      const data = JSON.parse(response);
      if (cartEl?.classList.contains('is-empty')) {
        cartEl.classList.remove('is-empty');
      }
      cartEl?.renderContents?.(data);
      notification?.addMessage?.(data);
    } catch {
      // ignore parse/render errors
    } finally {
      button.disabled = false;
      button.textContent = texts.addToCart;
    }
  });
}

function renderRecommendation(container, rec) {
  const texts = {
    youMayLike: container.dataset.youMayLikeText || 'You may like:',
    addToCart: container.dataset.addToCartText || 'Add to Cart',
    adding: container.dataset.addingText || 'Adding…',
  };

  container.innerHTML = `
    <a class="rc_link" href="${escapeHtml(rec.url)}">
      <div class="rc_img">
        ${rec.image ? `<img src="${escapeHtml(rec.image)}" width="auto" height="auto" alt="${escapeHtml(rec.title)}">` : ''}
      </div>
      <div class="rc_info">
        <p>${escapeHtml(texts.youMayLike)}</p>
        <p class="rc_title">${escapeHtml(rec.title)}</p>
      </div>
    </a>
    <button type="button" class="rc_add">${escapeHtml(texts.addToCart)}</button>
  `.trim();
  container.classList.add('related-product-content', 'is-loaded');

  container.querySelector('.rc_add')?.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    handleAdd(event.currentTarget, rec, texts);
  });
}

function processContainer(container) {
  if (container.dataset.ymlProcessed) return;
  container.dataset.ymlProcessed = 'true';

  fetchRecommendation(container.dataset.productId).then((rec) => {
    if (rec) renderRecommendation(container, rec);
  });
}

function scan(root) {
  root.querySelectorAll?.('[data-plp-yml]').forEach(processContainer);
}

const plpYouMayLike = () => {
  scan(document);

  const grids = document.querySelectorAll('#product-grid, .product-grid');
  if (grids.length) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches?.('[data-plp-yml]')) processContainer(node);
          scan(node);
        });
      });
    });

    grids.forEach((grid) =>
      observer.observe(grid, { childList: true, subtree: true }),
    );
  }

  // COB2B-804: the cart page re-renders its line items via the Section
  // Rendering API after every quantity change (assets/cart.js), swapping in
  // fresh markup that a grid-scoped MutationObserver never sees — rescan so a
  // line that just went out of stock gets its recommendation too.
  $(window).on('cart:quantity-update', () => scan(document));
};

export default plpYouMayLike;
